module.exports = __webpack_public_path__ + "img/wood@2x.789a4af7.png";